var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import classNames from "classnames";
import { Link } from "../link/Link";
import { logoCls, logoLinkCls, logoImageCls, logoPageTitleCls, logoTypeDefaultCls, logoTypeInitialsCls, logoTypeSquareCls, logoThemeWhiteCls, logoThemeBlackCls } from "./Logo.less";
import logoDefaultBlack from "./images/ra-logo-black.svg";
import logoDefaultWhite from "./images/ra-logo-white.svg";
import logoLettersBlack from "./images/ra-logo-letters-black.svg";
import logoLettersWhite from "./images/ra-logo-letters-white.svg";
import logoSquareBlack from "./images/ra-logo-square-black.svg";
import logoSquareWhite from "./images/ra-logo-square-white.svg";
var DEFAULT_TAG = "div";
var Logo = /* @__PURE__ */ __name(function Logo2(_ref) {
  var _ref$type = _ref.type, type = _ref$type === void 0 ? "default" : _ref$type, _ref$tag = _ref.tag, tag = _ref$tag === void 0 ? DEFAULT_TAG : _ref$tag, _ref$theme = _ref.theme, theme = _ref$theme === void 0 ? "black" : _ref$theme, className = _ref.className, _ref$title = _ref.title, title = _ref$title === void 0 ? null : _ref$title, _ref$alt = _ref.alt, alt = _ref$alt === void 0 ? "" : _ref$alt, _ref$linkTitle = _ref.linkTitle, linkTitle = _ref$linkTitle === void 0 ? "" : _ref$linkTitle, _ref$external = _ref.external, external = _ref$external === void 0 ? false : _ref$external, _ref$href = _ref.href, href = _ref$href === void 0 ? null : _ref$href, _ref$headingProps = _ref.headingProps, headingProps = _ref$headingProps === void 0 ? null : _ref$headingProps;
  var TYPE_TO_CLASSNAME = {
    "default": logoTypeDefaultCls,
    initials: logoTypeInitialsCls,
    square: logoTypeSquareCls
  };
  var LOGOS = {
    "default": {
      black: logoDefaultBlack,
      white: logoDefaultWhite
    },
    initials: {
      black: logoLettersBlack,
      white: logoLettersWhite
    },
    square: {
      black: logoSquareBlack,
      white: logoSquareWhite
    }
  };
  var THEME_TO_CLASSNAME = {
    white: logoThemeWhiteCls,
    black: logoThemeBlackCls
  };
  var logoImg = /* @__PURE__ */ React.createElement("img", {
    src: LOGOS[type][theme],
    alt,
    className: logoImageCls
  });
  var TitleTag = tag || DEFAULT_TAG;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(logoCls, type ? TYPE_TO_CLASSNAME[type] : TYPE_TO_CLASSNAME["default"], theme ? THEME_TO_CLASSNAME[theme] : THEME_TO_CLASSNAME.black, className)
  }, href === null ? logoImg : /* @__PURE__ */ React.createElement(Link, {
    external,
    title: linkTitle,
    to: href,
    className: logoLinkCls
  }, logoImg), title ? /* @__PURE__ */ React.createElement(TitleTag, _extends({}, headingProps, {
    className: classNames(logoPageTitleCls, headingProps && headingProps.className)
  }), title) : null);
}, "Logo");
export {
  Logo
};
